<template>
  <div class="concept-nav__container">
    <div class="concept-nav"  :style="{'--right-station-width': rightStationWidth + 'px'}">
      <div class="concept-nav-item" v-for="(concept, index) in $store.state.org.concepts" v-bind:key="index">
        <a :class="[isFocused[index]]" @mouseover="startScroll(concept)" @mouseleave="cancelScroll(concept)" @click="goToConcept(concept)">
          {{ concept.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ConceptsNav',
  components: {
  },
  data() {
      return {
        rightStationWidth: 210,
        scrollTimer: null,
        shouldScroll: {},
      }
  },
  computed: {
    isFocused(){
      var arr = [];
      for(var i = 0; i < this.$store.state.org.concepts.length; i++) {
        arr.push('');
      }

      arr[this.$store.state.stations.concepts.currentPosition] = 'focused';
      return arr;
    }
  },
  mounted() {
    this.$el.addEventListener('mousewheel', (e) => {
      e.preventDefault();
      this.$store.dispatch('addToConceptsScroll', e);
    });

    window.addEventListener("resize", this.windowResized);
    this.windowResized();
  },
  methods: {
    asyncTimeout(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    cancelScroll(concept){
      this.shouldScroll[concept.name] = false;
    },
    async startScroll(concept){
      this.shouldScroll = {};
      this.shouldScroll[concept.name] = true;
      await this.asyncTimeout(100);
      if(this.shouldScroll[concept.name] == true) {
        this.scrollToConcept(concept)
      }
    },
    scrollToConcept(concept) {
      this.$store.dispatch('scrollToConcept', concept.id);
    },
    goToConcept(concept) {
      let slug = encodeURIComponent(concept.name.toLowerCase());
      this.$store.dispatch('routing/goToConcept', { slug }, {root: true});
      this.$store.dispatch('closeRight');
    },
    windowResized(){
      let windowWidth = window.innerWidth;
      let columnSize = (windowWidth - (10 * 10)) / 9;
      let width = (columnSize * 2) + 10;
      this.rightStationWidth = width;
    }
  }
}

</script>

<style>
  .concept-nav__container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 15px;
    box-sizing: border-box;
    position: relative;
    pointer-events: all;
  }

  .concept-nav {
    display: flex;
    flex-direction: column;
    pointer-events: all;
    width: 100%;
    z-index: 10;
    position: relative;
    transform: translateY(-12px);
  }

  .concept-nav-item {
    position: relative;
  }

  .concept-nav a {
    text-decoration: none;
    color: var(--beige-700);

    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    overflow: hidden;
    width: calc(var(--right-station-width) - 32px);
  }

  .concept-nav a.focused {
    color: var(--beige-1000);
  }

  .concept-nav a:hover {
    cursor: pointer;
    background: transparent;
    color: var(--beige-1000);
  }

  .concept-nav a.focused:hover {
    color: var(--beige-1000);
  }
</style>
